import React from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { IProduct } from '../../interfaces';
import ProductList from './ProductList';

const ProductsSlider = React.memo(
  ({
    sectionTitle,
    loading,
    products,
    focusedItem,
    onFocusItem
  }: {
    sectionTitle: string;
    loading: boolean;
    products: IProduct[] | null;
    onFocusItem?: (itemIndex: string) => void;
    focusedItem?: string;
  }) => {
    const spinner = loading && (
      <Spinner animation="grow" size="sm" className="title-spinner" />
    );

    if (!loading && (!products || !products.length)) return null;

    return (
      <section
        className={`similar-products ${loading ? 'section-loading' : ''}`}
      >
        <>
          <div className="separator" id="product-slider-section" />
          <div className="section-container">
            <Container>
              <div className="light-text">
                {spinner}
                {sectionTitle}
                {spinner}
              </div>
              {!loading && !!products?.length && (
                <ProductList {...{ products, onFocusItem, focusedItem }} />
              )}
            </Container>
          </div>
        </>
        <style jsx>
          {`
            .similar-products {
              position: relative;
            }
            .similar-products .separator {
              display: block;
            }
            .similar-products .section-container {
              padding-bottom: 0;
            }
            .similar-products :global(.focus-btn) {
              background: transparent !important;
            }
            @media (min-width: 768px) {
              .similar-products .section-container {
                padding: 80px 0 70px;
              }
              .similar-products .light-text {
                text-align: center;
                font-size: 1.5em;
                text-transform: uppercase;
                letter-spacing: 2px;
                margin-bottom: 50px;
              }
            }

            .similar-products :global(.products-list .thumbnail) {
              text-align: center;
              width: 120px;
              margin: 0 10px;
              color: #000;
              text-decoration: none;
            }
            .similar-products :global(.products-list.desktop-list .thumbnail) {
              margin: 0;
            }

            .similar-products :global(.img-container) {
              width: 100%;
              background-size: auto 100%;
              background-position: center center;
              background-repeat: no-repeat;
            }
            .similar-products :global(.img-container img) {
              width: 100%;
              height: auto;
            }
          `}
        </style>
      </section>
    );
  }
);

export default ProductsSlider;
